// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        resourceId: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.resourceId !== undefined)
        result.resourceId = tsValueToJsonValueFns.int64(value.resourceId);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.resourceId !== undefined)
        result.resourceId = jsonValueToTsValueFns.int64(value.resourceId);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.resourceId !== undefined) {
        const tsValue = value.resourceId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.resourceId = value;
    }
    return result;
}
